"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _date = require("../../../utils/date");
var PriceMatrixCell = function PriceMatrixCell(props) {
  var daysCount = props.daysCount,
    isMobile = props.isMobile,
    target = props.target,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className;
  return /*#__PURE__*/_react["default"].createElement(Container, {
    className: className
  }, daysCount.map(function (date) {
    return /*#__PURE__*/_react["default"].createElement(Item, {
      isTarget: date === target.start_date,
      isMobile: isMobile,
      key: date
    }, (0, _date.formatDate)(date, 'd MMM'));
  }));
};
var Container = _styledComponents["default"].ul.withConfig({
  displayName: "PriceMatrixTitle__Container",
  componentId: "sc-1kogedn-0"
})(["display:flex;justify-content:end;"]);
var Item = _styledComponents["default"].li.withConfig({
  displayName: "PriceMatrixTitle__Item",
  componentId: "sc-1kogedn-1"
})(["width:", "px;height:24px;font-size:12px;color:#919499;display:flex;align-items:center;justify-content:center;", ""], function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile ? 72 : 58;
}, function (_ref2) {
  var isTarget = _ref2.isTarget;
  return isTarget && "\n    font-weight: 500;\n    background: rgba(248, 231, 28, 0.26);\n    border-radius: 4px 0 0 4px;\n    color: #17181A;\n  ";
});
var _default = exports["default"] = PriceMatrixCell;